import { searchWithinStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { css } from "styled-components";

styles.titleText = {
    ...styles.titleText,
    variant: "bodyBig" as "body",
    weight: "bold",
};

styles.searchTextField = {
    ...styles.searchTextField,
    cssOverrides: {
        ...styles.searchTextField?.cssOverrides,
        formInputWrapper: css`
            margin-top: 10px;
        `,
    },
    mergeCss: true,
};
